module.exports = __webpack_public_path__ + "7f737b31901f905505dac64bf59b94b8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/quizzes-large.png
// module id = 951
// module chunks = 0